import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import TransactionDetails from "./TransactionDetails";
import TransactionDetails1xbet from "./TransactionDetails1xbet";
import TransactionDetailsStake from "./TransactionDetailsStake";

function TransactionDetailsIndex() {
  const { is1xbet, isStake } = useMerchantTheme();

  if (is1xbet) return <TransactionDetails1xbet />;
  if (isStake) return <TransactionDetailsStake />;

  return <TransactionDetails />;
}

export default TransactionDetailsIndex;
